/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { P as PickerColumnOption, d as defineCustomElement$1 } from './p-ByjmWt3s.js';

const IonPickerColumnOption = PickerColumnOption;
const defineCustomElement = defineCustomElement$1;

export { IonPickerColumnOption, defineCustomElement };
